import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 bg-wc-dark text-white relative overflow-hidden" data-id="element-71">
      <div className="absolute inset-0 opacity-20" data-id="element-72">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiLz48L3N2Zz4=')] bg-repeat" data-id="element-73"></div>
      </div>

      <div className="container mx-auto px-4 max-w-4xl text-center relative z-10" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-75">
          <h2 className="text-5xl md:text-6xl text-wc-yellow mb-8" data-id="element-76">
            🚀 LLAMADO A LA ACCIÓN FINAL
          </h2>

          <p className="text-2xl md:text-3xl font-medium mb-6" data-id="element-77">
            ¿Vas a dejar pasar el Mundial más grande de la historia sin el álbum
            completo?
          </p>

          <div className="text-lg md:text-xl text-gray-300 mb-12 space-y-2" data-id="element-78">
            <p data-id="element-79">
              Miles de fanáticos del fútbol ya están eligiendo vivir esta
              experiencia diferente.
            </p>
            <p data-id="element-80">Sin sobres caros. Sin figuritas repetidas. Sin esperas.</p>
            <p className="text-white font-bold mt-4" data-id="element-81">
              Solo la emoción pura de completar el álbum del Mundial 2026.
            </p>
          </div>

          <div className="flex flex-col gap-6 max-w-2xl mx-auto" data-id="element-82">
            <a href="https://www.digitalbibliotec.online/cart/52276163608858:1" target="_blank" rel="noopener noreferrer" className="group relative bg-wc-blue hover:bg-blue-600 text-white p-6 rounded-2xl transition-all transform hover:scale-105 shadow-xl border border-blue-400" data-id="element-83">
              <div className="flex flex-col items-center" data-id="element-84">
                <span className="text-2xl font-display tracking-wide mb-2" data-id="element-85">
                  🟢 SÍ, QUIERO EL MEGAPACK 2026
                </span>
                <span className="text-xl font-bold text-blue-200 mb-2" data-id="element-86">
                  Solo $19.990 — Acceso Inmediato
                </span>
                <span className="text-sm text-blue-100" data-id="element-87">
                  Descarga instantánea · Todos los equipos · Figuritas
                  especiales incluidas
                </span>
              </div>
            </a>

            <a href="https://www.digitalbibliotec.online/cart/52276164100378:1" target="_blank" rel="noopener noreferrer" className="group relative bg-wc-red hover:bg-red-600 text-white p-6 rounded-2xl transition-all transform hover:scale-105 shadow-2xl border-2 border-wc-yellow" data-id="element-88">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-wc-yellow text-wc-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-89">
                LA OPCIÓN MÁS ELEGIDA
              </div>
              <div className="flex flex-col items-center" data-id="element-90">
                <span className="text-2xl font-display tracking-wide mb-2" data-id="element-91">
                  🏆 SÍ, QUIERO EL PACK HISTÓRICO COMPLETO
                </span>
                <span className="text-xl font-bold text-yellow-200 mb-2" data-id="element-92">
                  Solo $27.990
                </span>
                <span className="text-sm text-red-100" data-id="element-93">
                  2026 + Qatar 2022 + Rusia 2018 + Brasil 2014 + Sudáfrica 2010
                </span>
              </div>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}